<script setup>
import '@zafir.co.ao/lightray/style.css';
</script>

<template>
  <div>
    <slot />
  </div>
</template>
